module.exports = __webpack_public_path__ + "img/Carrousels STARTO_rdv_slide_3.c7d8e15c.png";